import type { Quote } from '../types/myaccount';

type QuoteReference = Pick<Quote, 'id' | 'quote_number' | 'erp_quote_id'>;
type QuoteStatusReference = Pick<Quote, 'status' | 'conversion_state' | 'converted_order_pay_url' | 'has_active_checkout_order' | 'can_convert_to_order'>;

const ERP_PLACEHOLDER_VALUES = new Set(['', '0', 'no', 'processing']);
const QUOTE_OPEN_STATUSES = new Set(['pending']);
const QUOTE_COMPLETED_STATUSES = new Set(['completed', 'quote-completed']);

export const getQuoteDisplayId = (quote: QuoteReference): string => {
    const erpQuoteId = String(quote.erp_quote_id || '').trim();
    if (erpQuoteId !== '' && !ERP_PLACEHOLDER_VALUES.has(erpQuoteId.toLowerCase())) {
        return erpQuoteId;
    }

    return 'Processing';
};

export const getQuoteDisplayStatus = (quote: QuoteStatusReference): string => {
    const status = String(quote.status || '').trim();
    const conversionState = String(quote.conversion_state || '').trim();

    if (conversionState !== '' && !QUOTE_COMPLETED_STATUSES.has(status)) {
        return conversionState;
    }

    return status;
};

export const canQuoteProceedToCheckout = (quote: QuoteStatusReference): boolean => {
    const status = String(quote.status || '').trim();
    const displayStatus = getQuoteDisplayStatus(quote);

    if (Boolean(quote.converted_order_pay_url)) {
        return true;
    }

    if (quote.can_convert_to_order === false) {
        return false;
    }

    if (quote.can_convert_to_order === true) {
        return true;
    }

    return QUOTE_OPEN_STATUSES.has(status) && displayStatus !== 'converted';
};

export const canQuoteBeEdited = (quote: QuoteStatusReference): boolean => {
    const status = String(quote.status || '').trim();
    const displayStatus = getQuoteDisplayStatus(quote);

    return !quote.has_active_checkout_order
        && displayStatus !== 'converted'
        && !QUOTE_COMPLETED_STATUSES.has(status)
        && status !== 'rejected';
};

export const getQuotePrimaryActionLabel = (quote: QuoteStatusReference): string => (
    quote.has_active_checkout_order || Boolean(quote.converted_order_pay_url)
        ? 'Pay Order'
        : 'Convert Quote'
);

export const getQuotePrimaryActionTitle = (quote: QuoteStatusReference): string => (
    quote.has_active_checkout_order || Boolean(quote.converted_order_pay_url)
        ? 'Pay linked order'
        : 'Convert quote to order'
);
